import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Badge } from './badge.component';

export * from './badge.component';

@NgModule({
  declarations: [
    Badge
  ],
  exports: [
    Badge
  ],
  imports: [
    CommonModule
  ]
})
export class BadgeModule {}
